export default ({ COLORS }) => ({
  container: {
    height: '232px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    backgroundColor: '#f9f9f9',
    padding: '8px',
    overflow: 'auto',
    position: 'relative'
  },
  pendingArea: {
    zIndex: '100',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    left: '1px',
    top: '1px',
    position: 'absolute',
    width: 'calc(100% - 2px)',
    height: 'calc(100% - 2px)',
    animation: '0.3s fadeIn ease-in'
  },
  notFound: {
    color: COLORS.TEXT.LIGHT_GREY.NORMAL,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  previews: {
    height: '100%',
    overflow: 'auto',
    display: 'flex',
    flexWrap: 'wrap'
  },
  '@keyframes fadeIn': {
    from: { opacity: '0' },
    to: { opacity: '1' }
  }
})
